"use client";

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from "@/components/error-boundary";
import { Tab, TabList, TabPanel, Tabs } from "@/components/rac/tabs";
import { SUPCard } from "@/components/sup/card";
import { usePropertyInteractionStore } from "@/stores/property-interaction-store";
import { type SellerUnitsAndProjectsOne } from "@/types/sup";
import React, { useMemo, useState } from "react";
interface AvailableSUPsProps {
  sups: SellerUnitsAndProjectsOne[];
}
const ProjectCardFallback = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center"><div className="text-red-800 font-semibold mb-2">Project Cards Error</div><p className="text-red-600 text-sm">Unable to load available properties</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="w-full p-6 border border-red-200 rounded-lg bg-red-50 relative">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export function AvailableSUPs(t0) {
  const $ = _c(20);
  const {
    sups
  } = t0;
  const [selectedTab, setSelectedTab] = useState("");
  const openPropertyOverlay = usePropertyInteractionStore(_temp);
  let t1;
  bb0: {
    if (!sups || sups.length === 0) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let groups;
    if ($[1] !== sups) {
      groups = {};
      sups.forEach(sup => {
        const bedroomCounts = sup.bedrooms || [];
        if (bedroomCounts.length === 0) {
          if (!groups.Other) {
            groups.Other = [];
          }
          groups.Other.push(sup);
        } else {
          bedroomCounts.forEach(bedroomCount => {
            const key_0 = bedroomCount === 1 ? "1 BHK" : `${bedroomCount} BHK`;
            if (!groups[key_0]) {
              groups[key_0] = [];
            }
            groups[key_0].push(sup);
          });
        }
        if (sup.type === "sp") {
          sup.mediaList = [...(sup.mediaList || []).filter(_temp2), ...(sup.mediaList || []).filter(_temp3)];
        }
      });
      $[1] = sups;
      $[2] = groups;
    } else {
      groups = $[2];
    }
    t1 = groups;
  }
  const groupedSUPs = t1;
  let t2;
  if ($[3] !== groupedSUPs) {
    t2 = Object.entries(groupedSUPs).sort(_temp4);
    $[3] = groupedSUPs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sortedGroups = t2;
  const defaultSelectedKey = sortedGroups[0]?.[0] || "";
  if (!sups || sups.length === 0 || sortedGroups.length === 0) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="my-4 bg-accent-300 text-primary p-4 mb-2 rounded-full" role="alert"><p className="text-center font-bold">❗ No units available for sale right now.</p></div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  const t3 = selectedTab || defaultSelectedKey;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = key_1 => setSelectedTab(key_1 as string);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sortedGroups) {
    t5 = sortedGroups.map(_temp5);
    $[7] = sortedGroups;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <TabList className="mb-6">{t5}</TabList>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== openPropertyOverlay || $[12] !== sortedGroups) {
    let t8;
    if ($[14] !== openPropertyOverlay) {
      t8 = t9 => {
        const [bedroomType_0, groupSUPs] = t9;
        return <TabPanel key={bedroomType_0} id={bedroomType_0}><div className="grid grid-cols-1 @lg:grid-cols-2 @4xl:grid-cols-3 gap-4">{groupSUPs.map(sup_0 => <div key={sup_0._id} onClick={() => openPropertyOverlay({
              sups: [sup_0],
              initialSupId: sup_0._id,
              projectName: sup_0.projectName
            })}><SUPCard data={sup_0} shouldRedirect={false} /></div>)}</div></TabPanel>;
      };
      $[14] = openPropertyOverlay;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = sortedGroups.map(t8);
    $[11] = openPropertyOverlay;
    $[12] = sortedGroups;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t6 || $[18] !== t7) {
    t8 = <ErrorBoundary fallback={ProjectCardFallback}><div className="w-full"><Tabs selectedKey={t3} onSelectionChange={t4}>{t6}{t7}</Tabs></div></ErrorBoundary>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp5(t0) {
  const [bedroomType] = t0;
  return <Tab key={bedroomType} id={bedroomType}>{bedroomType}</Tab>;
}
function _temp4(a, b) {
  if (a[0] === "Other") {
    return 1;
  }
  if (b[0] === "Other") {
    return -1;
  }
  const aNum = parseInt(a[0]);
  const bNum = parseInt(b[0]);
  return aNum - bNum;
}
function _temp3(media_0) {
  return media_0.name !== "Floorplan";
}
function _temp2(media) {
  return media.name === "Floorplan";
}
function _temp(state) {
  return state.openPropertyOverlay;
}